import React from 'react';
import PropTypes from 'prop-types';

function OneStopShopTwo(props) {
  const { height, width } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 84" width={width} height={height}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#fff"
            d="M33,.43A38.87,38.87,0,0,1,69.5,15.18l3,3.89,3.19-3.75a29.49,29.49,0,0,1,45.24.31l1.61,1.94L125,17a7.34,7.34,0,0,1,.84-.17,8.88,8.88,0,0,1,5,.7h.06a8.78,8.78,0,0,1,1.41.77l.08,0,.08.05L137,21a9,9,0,0,1,.84,14.89l-1.29,1-.24,1.6c-2.73,17.78-15.35,30.91-32.15,33.44-13.25,2-25.72-1.86-34.21-10.59l-3.15-3.23L64,61.63a29.52,29.52,0,0,1-49.25-5l-.19-.35-.25-.32a8.64,8.64,0,0,1-.85-1.25l-1.2-2.16-2.47.11A9,9,0,0,1,.44,45,39.07,39.07,0,0,1,33,.43"
          />
          <path
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            d="M127.53,26.76C130.36,45.51,119.26,61.57,103,64S71.81,57.74,69.33,41.26l-.79-5.54a29.86,29.86,0,1,0-59,8.89"
          />
          <polyline
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            points="132.53 29.76 127.33 26.68 123.33 31.15"
          />
          <circle fill="#6a445a" cx="98.34" cy="35.45" r="20.38" />
          <path
            fill="#52b7b0"
            opacity={0.4}
            d="M50.1,22.71,26.3,55.34a19.93,19.93,0,0,0,28.08-4.23A20.47,20.47,0,0,0,50.1,22.71Z"
          />
          <ellipse
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            cx="38.24"
            cy="40.41"
            rx="3.92"
            ry="3.97"
            transform="translate(-5.59 6.15) rotate(-8.57)"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="41.15"
            y1="36.69"
            x2="46.7"
            y2="29.09"
          />
          <path
            fill="#fff"
            d="M97.75,27.78V25.16h2.39l0,2.65a19.74,19.74,0,0,1,3.63.64v2.18a16.54,16.54,0,0,0-5.08-.84c-2.39,0-3.58.67-3.59,2s.75,1.91,2.25,1.92h2c3.27,0,4.9,1.43,4.89,4.25q0,3.42-4.19,4v2.7H97.67v-2.6a20.17,20.17,0,0,1-4.48-.69V39.19a16.61,16.61,0,0,0,5.1.84c2.28,0,3.42-.67,3.43-2s-.79-1.91-2.38-1.92h-2c-3.09,0-4.62-1.43-4.61-4.25C92.71,29.31,94.39,28,97.75,27.78Z"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="35.77"
            y1="19.71"
            x2="35.37"
            y2="16.91"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="42.12"
            y1="61.83"
            x2="41.72"
            y2="59.03"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="58.21"
            y1="36.93"
            x2="61.01"
            y2="36.53"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="15.87"
            y1="43.31"
            x2="18.67"
            y2="42.91"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="50.92"
            y1="23.46"
            x2="52.61"
            y2="21.2"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="25.03"
            y1="58.53"
            x2="26.72"
            y2="56.27"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="54.28"
            y1="51.26"
            x2="56.54"
            y2="52.96"
          />
          <line
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            x1="20.15"
            y1="26.07"
            x2="22.41"
            y2="27.77"
          />
        </g>
      </g>
    </svg>
  );
}

OneStopShopTwo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

OneStopShopTwo.defaultProps = {
  height: 84,
  width: 140
};

export default OneStopShopTwo;
